import { LanguageCodes } from '../configuration/constants/enums'

const getI18nMap = (languageCode: LanguageCodes) => {
  switch (languageCode) {
    case LanguageCodes.SPANISH:
      return import(
        /* webpackChunkName: "i18n-locales-es" */
        /* webpackExports: ["default"] */
        './es'
      )
    case LanguageCodes.ENGLISH:
    default:
      return import(
        /* webpackChunkName: "i18n-locales-en" */
        /* webpackExports: ["default"] */
        './en'
      )
  }
}

export default getI18nMap
